import {mapActions, mapGetters, mapMutations} from 'vuex';
import Item from '@/components/main-item/index.vue'
import HeadFilter from '@/components/features/head-filter/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'
import {seo} from '@/mixins/seo'

export default {
    name: 'news-main',
    mixins: [seo],
    components: {
        Item,
        HeadFilter,
        BtnLoadMore
    },
    data() {
        return {
            seo: {
                title: this.$t('news'),
            }
        }
    },
    computed: {
        ...mapGetters({
            list: 'news/list',
            listLength: 'news/listLength',
            isLoading: 'news/isLoading',

            categories: 'news/categories',
            isLoadingCategories: 'news/isLoadingCategories',
        }),
    },
    created() {
        if (!this.categories.length) {
            this.fetchCategories()
        }
    },
    methods: {
        ...mapActions({
            fetchList: 'news/GET_LIST',
            fetchCategories: 'news/GET_CATEGORIES',
        }),
        ...mapMutations({
            changeCategory: 'news/CHANGE_CATEGORY',
            setCategories: 'news/SET_CATEGORIES',
        }),
    },
}
